import { infoProfileContactHospitalPresentationTypes } from "../../constantes/actionTypes"

const initialState = []

export const infoProfileContactHospitalPresentation = (state = initialState, action) => {
    switch (action.type) {
        case infoProfileContactHospitalPresentationTypes.GET_INFO_CONTACT_HOSPITAL_PRESENTATION_SUCCESS:
            return action.payload
        case infoProfileContactHospitalPresentationTypes.GET_INFO_CONTACT_HOSPITAL_PRESENTATION_FAILURE:
            return initialState
        default:
            return state
    }
}